import {Baseline} from '../interfaces';
import apiGraphQL from './apiGraphQL';

export function getBaselines(profileId: number, types: string[]) {
  return new Promise<Baseline[]>((resolve, reject) => {
    try {
      apiGraphQL
        .post('/graphql', {
          query: `query GetBaselines($profileId: Int, $types: [String]) {
            baselines (profileId: $profileId, types: $types) {
              id
              type
              accelAvgV2
              accelMaxV2
              strintFilteredStrideRateAvgV2
              strintFilteredStrideRateMaxV2
              speedAvgV2
              speedMaxV2
              hrAvg
              hrMax
              energyRatio
              balanceNormalized
              lastSessionDate
              shiftTimeAvg
              activeTime
              calculatedShiftCount
              strideCountLeft
              strideCountRight
            }
          }`,
          variables: {
            profileId,
            types,
          },
        })
        .then(response => {
          resolve(response.data.data.baselines);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}
